/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_UsageInputs */

const da_privacy_data_usage = /** @type {(inputs: Privacy_Data_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Brug og drift:** logins (tidspunkt, IP-adresse og browsertype), fejl og forbrug af AI (antal kald, omfang og pris) med tidspunkt.`)
};

/** @type {(inputs: Privacy_Data_UsageInputs) => LocalizedString} */
const en_privacy_data_usage = da_privacy_data_usage;

/**

* @param {Privacy_Data_UsageInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_data_usage = /** @type {((inputs?: Privacy_Data_UsageInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_UsageInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_data_usage(inputs)
	return /** @type {LocalizedString} */ ("**Brug og drift:** logins (tidspunkt, IP-adresse og browsertype), fejl og forbrug af AI (antal kald, omfang og pris) med tidspunkt.")
});